import { http, HttpResponse } from 'msw';

import { OperatorTask } from 'modules/common/components/LaunchpadProgress/LaunchpadProgress.interface';

export default {
    operatorTasksList: http.get('*/v2/members/tasks/', () => HttpResponse.json([] satisfies OperatorTask[])),
    operatorTaskStatus: http.post('*/v2/members/tasks/:id/status/', () => HttpResponse.json({ status: 'completed' })),
};
